export const LoadPopupTranslations = {
  removeLoad: 'Remove load?',
  subTile1: 'Removing the load will also delete the Manifest',
  subTitle2:
    'Removing the load will also remove all of its stops from manifest trip',
  sureRemoveLoad: 'Are you sure you want to remove this load?',
};
